import { createGlobalStyle } from "antd-style";
import variableColors from "@/base/global/variables/figma.colors.json";

export const GlobalScroll = createGlobalStyle`
  *::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  * {
    text-rendering: optimizeLegibility;
  }

  *::-webkit-scrollbar-track {
    border-radius: 4px;
    background-color: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${variableColors["ColorFigmaNeutralGrayscaleGray70"]};
    border-radius: 4px;
  }
`;
